<template>
  <div class="modal default-modal amount-modal modal-open">
    <div class="table">
      <div class="table-cell">
        <div class="modal-container align-center">
          <a href="" class="close" @click.prevent="$emit('close')">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="15.5" stroke="black" />
              <path
                d="M18.2031 16L23.2656 10.9844C23.5469 10.7031 23.5469 10.1875 23.2656 9.90625L22.0938 8.73438C21.8125 8.45312 21.2969 8.45312 21.0156 8.73438L16 13.7969L10.9375 8.73438C10.6562 8.45312 10.1406 8.45312 9.85938 8.73438L8.6875 9.90625C8.40625 10.1875 8.40625 10.7031 8.6875 10.9844L13.75 16L8.6875 21.0625C8.40625 21.3438 8.40625 21.8594 8.6875 22.1406L9.85938 23.3125C10.1406 23.5938 10.6562 23.5938 10.9375 23.3125L16 18.25L21.0156 23.3125C21.2969 23.5938 21.8125 23.5938 22.0938 23.3125L23.2656 22.1406C23.5469 21.8594 23.5469 21.3438 23.2656 21.0625L18.2031 16Z"
                fill="black"
              />
            </svg>
          </a>

          <p>{{ item.title }}</p>

          <div class="modal-content">
            <div class="amount">
              <i
                class="minus"
                :class="{
                  disabled: !card.find((it) => it.productId === item.product_id),
                }"
                @click.prevent="
                  changeAmount({
                    productId: item.product_id,
                    action: 'DECREMENT_AMOUNT_CARD',
                  })
                "
                ><svg
                  width="100%"
                  height="auto"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#f37920" />
                  <path
                    d="M7.035 13.36H16.971V11.68H7.035V13.36Z"
                    fill="white"
                  />
                </svg>
              </i>
              <b>{{
                card.find((it) => it.productId === item.product_id)
                  ? card.find((it) => it.productId === item.product_id).amount
                  : 0
              }}</b>
              <i
                class="plus"
                :class="{
                  disabled:
                    parseInt(item.volume) <=
                    parseInt(
                      card.find((it) => it.productId === item.product_id)
                        ? card.find((it) => it.productId === item.product_id)
                            .amount
                        : ''
                    ),
                }"
                @click.prevent="
                  changeAmount({
                    productId: item.product_id,
                    action: 'INCREMENT_AMOUNT_CARD',
                  })
                "
                ><svg
                  width="100%"
                  height="auto"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#f37920" />
                  <path
                    d="M6.55444 12.2H11.0664V16.832H12.8664V12.2H17.4504V10.52H12.8664V5.936H11.0664V10.52H6.55444V12.2Z"
                    fill="white"
                  />
                </svg>
              </i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AmountShop",
  props: ["item"],
  computed: {
    ...mapState("shop", {
      catalog: (state) => state.index,
      card: (state) => state.card,
    }),
    cat() {
      return this.catalog[this.category];
    },
  },
  methods: {
    ...mapActions("shop", {
      actionIndex: "index",
      changeAmount: "changeAmount",
    }),
  },
  mounted() {},
};
</script>

<style scoped>
.disabled {
  opacity: 0.4;
}
</style>
